import { render } from "./profil-vue.vue?vue&type=template&id=47575cc8"
import script from "./profil-vue.vue?vue&type=script&lang=js"
export * from "./profil-vue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__